import React from 'react'
import { Button } from '@mui/material'

function Submitbtn({
  name,
  width,
  height,
  color,
  borderRadius,
  fontWeight,
  fontSize,
  onClick,
  disabled = false,
  type = "button"
}) {
  return (
    <Button
      type={type}
      disabled={disabled}
      sx={{
        width: width,
        height: height,
        color: color,
        fontSize: fontSize,
        fontWeight: fontWeight,
        textTransform: "none",
        borderRadius: borderRadius,
        backgroundColor: disabled ? "rgba(105, 83, 55, 0.3)" : "rgba(105, 83, 55, 1)",
        '&:hover': {
          backgroundColor: disabled ? "rgba(105, 83, 55, 0.3)" : 'rgba(105, 83, 55, 1)',
          boxShadow: 'none',
        },
        "&.Mui-disabled": {
          backgroundColor: "rgba(105, 83, 55, 0.3)",
          color: "rgba(255, 255, 255, 0.9)"
        }
      }}
      onClick={onClick}
    >
      {name}
    </Button>
  )
}

export default Submitbtn